export const  filterCorp = ({ dataList, updatedDataList, key, filterKey = 'corporate_name' }) => {
    const filtered = dataList.filter((item) => {
        return updatedDataList.indexOf(item[key]) > -1;
    });
    const corporates = filtered.map((item) => item[filterKey] || 'GoShare');
    return corporates;
};
